// extracted by mini-css-extract-plugin
export default {"container":"KybManualForm_container__owy0j","footer":"KybManualForm_footer__U1ftW"};